import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Pricing from '../components/Pricing';
import ZoneIntervention from '../components/ZoneIntervention';
import Gallery from '../components/Gallery';
import About from '../components/About';
import Reviews from '../components/Reviews';
import FAQ from '../components/FAQ';
import TermsConditions from '../components/TermsConditions';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <Services />
      <Pricing />
      <ZoneIntervention />
      <Gallery />
      <About />
      <Reviews />
      <FAQ />
      <TermsConditions />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;
